import React from "react";
import { ChipsPopup } from "./ChipsPopup";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";
export function WatermelonPlayNoticePopup(props) {
  ChipsPopup(
    props,
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginBottom: calc(20),
      }}
    >
      <div
        style={{
          width: calc(200),
          marginTop: calc(16),
          padding: `0 ${calc(16)}`,
          color: "#3D3D3D",
          textAlign: "center",
          fontFamily: "Spoqa Han Sans Neo",
          fontSize: calc(18),
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "150%",
          flex: "1 0 0",
        }}
      >
        {props.title}
      </div>

      <div
        style={{
          position: "absolute",
          top: calc(12),
          right: calc(8),
          padding: calc(8),
          cursor: "pointer",
        }}
        onClick={() => {
          if (!props.close || !props.close()) {
            props.dismiss();
          }
        }}
      >
        <img
          style={{
            width: calc(20),
            height: calc(20),
          }}
          src="/games/fruits/assets/ic-title-back.png"
        />
      </div>

      {props.image ? (
        <div
          style={{
            width: calc(200),
            height: calc(120),
            borderRadius: calc(10),
            marginTop: calc(16),
            background: "#FFE6A7",
            overflow: "hidden",
          }}
        >
          <img
            style={{
              width: calc(120),
            }}
            src={props.image}
          />
        </div>
      ) : null}

      {props.message ? (
        <div
          style={{
            color: "#3D3D3D",
            textAlign: "center",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(15),
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "150%",
            padding: `0 ${calc(16)}`,
            marginTop: calc(16),
          }}
          dangerouslySetInnerHTML={{ __html: props.message }}
        ></div>
      ) : null}
    </div>,
  );
}
